import { book } from './book'
import { search } from './search'

export const handlers = [book, search]
